import { render, staticRenderFns } from "./StoreForSales.vue?vue&type=template&id=488b854c"
import script from "./StoreForSales.vue?vue&type=script&lang=js"
export * from "./StoreForSales.vue?vue&type=script&lang=js"
import style0 from "./StoreForSales.vue?vue&type=style&index=0&id=488b854c&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports